var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"typenav"},[_c('TypeNav',{attrs:{"rootMenus":_vm.rootMenus},on:{"switchover":_vm.cut}})],1),_c('div',{staticClass:"box"},[_c('div',{staticClass:"right"},[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('div',{staticClass:"main-content"},[_c('router-view')],1)])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }